import { apiAxios } from '@app/api-client';
import type {
  DocumentCreateInput,
  DocumentDto,
  DocumentListQuery,
  DocumentUpdateInput,
  DocumentValueCreateInput,
  DocumentValueDto,
  DocumentValueUpdateInput,
} from '@app/contracts';

// --- Documents ---

export const fetchDocuments = (params?: DocumentListQuery): Promise<DocumentDto[]> => {
  const query = params?.extension ? `?extension=${params.extension}` : '';
  return apiAxios<DocumentDto[]>({ url: `/api/v1/documents${query}`, method: 'GET' });
};

export const fetchDocument = (id: string): Promise<DocumentDto> =>
  apiAxios<DocumentDto>({ url: `/api/v1/documents/${id}`, method: 'GET' });

export const createDocument = (input: DocumentCreateInput): Promise<DocumentDto> =>
  apiAxios<DocumentDto>({ url: '/api/v1/documents', method: 'POST', data: input });

export const updateDocument = (id: string, input: DocumentUpdateInput): Promise<DocumentDto> =>
  apiAxios<DocumentDto>({ url: `/api/v1/documents/${id}`, method: 'PATCH', data: input });

export const deleteDocument = (id: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/documents/${id}`, method: 'DELETE' });

export const publishDocument = (id: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/documents/${id}/publish`, method: 'POST' });

// --- Document Values ---

export const fetchDocumentValues = (documentId: string): Promise<DocumentValueDto[]> =>
  apiAxios<DocumentValueDto[]>({
    url: `/api/v1/documents/${documentId}/values`,
    method: 'GET',
  });

export const createDocumentValue = (
  documentId: string,
  input: DocumentValueCreateInput,
): Promise<DocumentValueDto> =>
  apiAxios<DocumentValueDto>({
    url: `/api/v1/documents/${documentId}/values`,
    method: 'POST',
    data: input,
  });

export const updateDocumentValue = (
  documentId: string,
  valueId: string,
  input: DocumentValueUpdateInput,
): Promise<DocumentValueDto> =>
  apiAxios<DocumentValueDto>({
    url: `/api/v1/documents/${documentId}/values/${valueId}`,
    method: 'PATCH',
    data: input,
  });

export const deleteDocumentValue = (documentId: string, valueId: string): Promise<void> =>
  apiAxios<void>({
    url: `/api/v1/documents/${documentId}/values/${valueId}`,
    method: 'DELETE',
  });
